import React from "react";

const Byerrfqs = () => {

    return (
        <div className="buyer-dashboard">
            <div className="text">Welcome to Amtpl Buyer RFQs page</div>


        </div>
    );
};

export default Byerrfqs